// extracted by mini-css-extract-plugin
export default {"overlay":"PasswordGate_overlay__W4EWu","form":"PasswordGate_form__PG-9b","label":"PasswordGate_label__Wl7D1","input":"PasswordGate_input__9vYR3","error":"PasswordGate_error__wKUBt"};